import { v4 as uuidv4 } from 'uuid';

export function randomUUID(): string {
  return uuidv4();
}
